import PageLayout from '@/components/page/page-layout'

const RefundList = () => import('@/views/refund/list')

const router = {
  path: '/refund',
  component: PageLayout,
  redirect: '/refund/list',
  name: 'Refund',
  icon: 'none',
  children: [
    {
      path: 'list',
      name: 'refundList',
      component: RefundList,
      meta: {
        currentMenu: 'refund',
        hideBreadcrumb: true,
        title: '退款查询'
      }
    }
  ]
}

export default router
